/**
 * Encode Float32Array PCM samples to a WAV Blob.
 */
export function encodeWAV(samples, sampleRate = 16000) {
  function floatTo16BitPCM(output, offset, input) {
    for (let i = 0; i < input.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, input[i]));
      output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
    }
  }

  const buffer = new ArrayBuffer(44 + samples.length * 2);
  const view = new DataView(buffer);

  // WAV header
  view.setUint32(0, 0x52494646, false); // RIFF
  view.setUint32(4, 36 + samples.length * 2, true); // file length
  view.setUint32(8, 0x57415645, false); // WAVE
  view.setUint32(12, 0x666d7420, false); // fmt
  view.setUint32(16, 16, true); // format chunk length
  view.setUint16(20, 1, true); // sample format (raw)
  view.setUint16(22, 1, true); // channel count
  view.setUint32(24, sampleRate, true); // sample rate
  view.setUint32(28, sampleRate * 2, true); // byte rate
  view.setUint16(32, 2, true); // block align
  view.setUint16(34, 16, true); // bits per sample
  view.setUint32(36, 0x64617461, false); // data
  view.setUint32(40, samples.length * 2, true); // data chunk length

  floatTo16BitPCM(view, 44, samples);
  return new Blob([view], { type: "audio/wav" });
}
